module.exports = __webpack_public_path__ + "static/media/Cooked_Cactus_Flesh.b0f38c1c.webp";